import BasicLayout from "@/layouts/basic-layout";

const meta = {
    auth: false,
    cache: false,
};
export default {
    path: "/performanceManagement",
    name: "performanceManagement",
    redirect: {
        name: "performanceManagement",
    },
    meta,
    component: BasicLayout,
    children: [{
            path: "/performanceManagement/performancePlan1/:queryType",
            name: "performancePlanList",
            meta: {
                ...meta,
                title: "管理员绩效方案",
            },
            component: () => import("@/pages/performanceManagement/performancePlan/index.vue"),
        },
        {
            path: "/performanceManagement/performancePlan2/:queryType",
            name: "testPerformancePlanList",
            meta: {
                ...meta,
                title: "考核员绩效方案",
            },
            component: () => import("@/pages/performanceManagement/performancePlan/index.vue"),
        },
        {
            path: "/performanceManagement/performancePlan/performanceReview",
            name: "performanceReview",
            meta: {
                ...meta,
                title: "绩效预览",
            },
            component: () => import("@/pages/performanceManagement/performancePlan/performanceReview.vue"),
        },
        {
            path: "/performanceManagement/performancePlan/add",
            name: "performancePlanAdd",
            meta: {
                ...meta,
                title: "创建绩效方案",
            },
            component: () => import("@/pages/performanceManagement/performancePlan/addPlan.vue"),
        },
        {
            path: "/performanceManagement/performancePlan/edit",
            name: "performancePlanEdit",
            meta: {
                ...meta,
                title: "编辑绩效方案",
            },
            component: () => import("@/pages/performanceManagement/performancePlan/addPlan.vue"),
        },
        {
            path: "/performanceManagement/performanceIndicators/list",
            name: "performanceIndicatorsList",
            meta: {
                ...meta,
                title: "绩效指标",
            },
            component: () => import("@/pages/performanceManagement/performanceIndicators/index.vue"),
        },
        {
            path: "/performanceManagement/allPerformance/list",
            name: "allPerformanceList",
            meta: {
                ...meta,
                title: "全部绩效",
            },
            component: () => import("@/pages/performanceManagement/allPerformance/index.vue"),
        },
        {
            path: "/performanceManagement/allPerformance/listDetail",
            name: "allPerformanceDetail",
            meta: {
                ...meta,
                title: "绩效详情",
            },
            component: () => import("@/pages/performanceManagement/allPerformance/detail.vue"),
        },
        {
            path: "/performanceManagement/myPerformance/list",
            name: "myPerformanceList",
            meta: {
                ...meta,
                title: "我的绩效",
            },
            component: () => import("@/pages/performanceManagement/myPerformance/index.vue"),
        },
        {
            path: "/performanceManagement/myPerformance/detail",
            name: "myPerformanceDetail",
            meta: {
                ...meta,
                title: "绩效确认",
            },
            component: () => import("@/pages/performanceManagement/myPerformance/detail.vue"),
        },
        {
            path: "/performanceManagement/salary/list",
            name: "salaryList",
            meta: {
                ...meta,
                title: "工资管理",
            },
            component: () => import("@/pages/performanceManagement/salaryManagement/index.vue"),
        },
        {
            path: "/performanceManagement/mySalary/list",
            name: "mySalaryList",
            meta: {
                ...meta,
                title: "我的工资条",
            },
            component: () => import("@/pages/performanceManagement/mySalary/index.vue"),
        },
        {
            path: "/performanceManagement/salaryManagement/edit",
            name: "mySalaryEdit",
            meta: {
                ...meta,
                title: "工资表编辑",
            },
            component: () => import("@/pages/performanceManagement/salaryManagement/salaryEdit.vue"),
        },
    ],
};